export const NOTIFICATIONS_CLIENTID = 'atlas-api';

export const ARCHIVES_NOTIFICATION_TYPE = 'NOTIFICATION_TYPE_ARCHIVES_API';
export const NOTIFICATION_TYPE_UNPACK_EDM = 'NOTIFICATION_TYPE_UNPACK_EDM';

export enum WebsocketEvents {
  ChangeScope = 'CHANGE_SCOPE',
  NotificationMessage = 'NOTIFICATION_MESSAGE',
}

export enum NotificationEventType {
  Unpack = 'Unpack',
  Progress = 'Progress',
  DesignSync = 'DesignSync',
}

export enum NotificationNames {
  UnpackEdmFile = 'Unpack EDM file',
  ParseFile = 'Parse file',
}

export enum NotificationEventStatusType {
  Started = 'Started',
  Success = 'Success',
  Finished = 'Finished',
  Error = 'Failed',
  Queued = 'Queued',
  Running = 'Running',
  Initialising = 'Initialising',
}

export enum DesignSyncStatusType {
  Synched = 'synched',
  Error = 'error',
}
